export default __webpack_public_path__ + "static/media/01_DAIF_Data_05_Loop.9b86ad0f.mp4";